import VitalSignCreateAndEditController from './vital-sign-create-and-edit-controller'
import {FieldAPI, Metadata } from '@philips-internal/oswald-ui-components';

interface VitalSignFields {
  field: FieldAPI;
  metadata?: Metadata;
}

class VitalSignFieldsMap {

  static makeData(vital: VitalSignCreateAndEditController): Record<string, VitalSignFields> {
    const dataMap: Record<string, VitalSignFields> = {
      CD_ESCALA_DOR: { field: vital.fieldCdPainScaleApi },
      DS_IMC: { field: vital.fieldImcDescriptionApi },
      DS_OBSERVACAO: { field: vital.fieldObstetricRecordsObservationApi },
      DT_DELTA_PESO: { field: vital.fieldDateOfWeightApi },
      IE_APARELHO_PA: { field: vital.fieldDevicePaApi },
      IE_BABINSKI: { field: vital.fieldBabinskiApi },
      IE_COND_SAT_O2: { field: vital.fieldSaturationConditionApi },
      IE_DECUBITO: { field: vital.fieldDecubitusApi },
      IE_DERIVACAO_SEG_ST: { field: vital.fieldStDerivationApi },
      IE_FREQUENCIA_DOR: { field: vital.fieldFrequencyApi },
      IE_GLIC_EXTRAPOL: { field: vital.fieldBloodGlucoseControlApi },
      IE_LADO: { field: vital.fieldIeSIdeApi },
      IE_LADO_DOR: { field: vital.fieldOutcastSideApi },
      IE_MANGUITO: { field: vital.fieldCuffPaApi },
      IE_MEMBRO: { field: vital.fieldMemberPaApi },
      IE_MEMBRO_SAT_O2: { field: vital.fieldSaturationMemberApi },
      IE_NIVEL_CONF_DOR: { field: vital.fieldPainComfortLevelApi },
      IE_NIVEL_CONSCIENCIA: { field: vital.fieldLevelOfConsciousnessApi },
      IE_ORIGEM_ALTURA: { field: vital.fieldHeightOriginApi },
      IE_ORIGEM_PESO: { field: vital.fieldOriginWidthApi },
      IE_PERIODO: { field: vital.fieldTimeCourseApi },
      IE_PRESSAO: { field: vital.fieldPositionPaApi },
      IE_PUPILA_ALTERACAO: { field: vital.fieldAlterationApi },
      IE_PUPILA_LADO: { field: vital.fieldSidePupilApi },
      IE_PUPILA_REACAO_LUZ: { field: vital.fieldRightEyeLightReactionApi },
      IE_PUPILA_REACAO_LUZ_E: { field: vital.fieldLeftEyeLightReactionApi },
      IE_RITMO_ECG: { field: vital.fieldEcgRhythmApi },
      IE_SINAL_FOCAL: { field: vital.fieldFocalSignalApi },
      IE_SINAL_FOCAL_LOCAL: { field: vital.fieldFocalSignalSpotApi },
      IE_SITIO: { field: vital.fieldPlaceApi },
      IE_TIPO_DOR: { field: vital.fieldKindOfPainApi },
      IE_UM_TEMP: { field: vital.temperatureUnityFieldAPI },
      IE_UNID_MED_ALTURA: { field: vital.fieldHeightUnitMeasureApi },
      IE_UNID_MED_O2_SUPLEM: { field: vital.fieldUmAdditionalApi },
      IE_UNID_MED_PESO: { field: vital.fieldWeightUnitMeasureApi },
      NR_SEQ_CONDICAO_DOR: { field: vital.fieldPainConditionApi },
      NR_SEQ_CONDUTA: { field: vital.fieldConductRecordApi },
      NR_SEQ_INAPTO_DOR: { field: vital.fieldIneptReasonPainApi },
      NR_SEQ_RESULT_DOR: { field: vital.fieldResultApi },
      NR_SEQ_TOP_DOR_IRRADIA: { field: vital.fieldIrradiationTopographyApi },
      NR_SEQ_TOPOGRAFIA_DOR: { field: vital.fieldTopographyApi },
      QT_ALTURA_CM: { field: vital.fieldHeightCentimetersApi},
      QT_ALTURA_M: { field: vital.fieldHeightMetersApi},
      QT_ANGULO_CABECEIRA: { field: vital.fieldDegreesApi },
      QT_BCF: { field: vital.fieldObstetricRecordsApi },
      QT_BCF_2: { field: vital.fieldObstetricRecordsBcf2Api },
      QT_BCF_3: { field: vital.fieldObstetricRecordsBcf3Api },
      QT_BILIRRUBINA_FRONTE: { field: vital.fieldBtfApi },
      QT_BILIRRUBINA_TRONCO: { field: vital.fieldBttApi },
      QT_CIRCUNF_BRACO: { field: vital.fieldArmCircumferenceApi },
      QT_CIRCUNF_PANTURRILHA: { field: vital.fieldCalfCircumferenceApi },
      QT_CMB: { field: vital.fieldCmbApi },
      QT_DELTA_PESO: { field: vital.fieldDeltaWeightApi },
      QT_ESCALA_DOR: { field: vital.fieldPainScaleApi },
      QT_FREQ_CARDIACA: { field: vital.fieldHeartRateApi },
      QT_FREQ_RESP: { field: vital.fieldRespiratoryFrequencyApi },
      QT_GLIC_MEDIA_DIA: { field: vital.field24HourAverageApi },
      QT_GLICEMIA_CAPILAR: { field: vital.fieldCapillaryBloodGlucoseApi },
      QT_GLICOSE_ADM: { field: vital.fieldGlucoseApi },
      QT_INSULINA: { field: vital.fieldInsulinApi },
      QT_IRRADIANCIA: { field: vital.fieldRadianceApi },
      QT_O2_SUPLEMENTAR: { field: vital.fieldO2AdditionalApi },
      QT_PA_DIASTOLICA: { field: vital.fieldPadApi },
      QT_PA_SISTOLICA: { field: vital.fieldPasApi },
      QT_PAE: { field: vital.fieldPaeMmhfApi },
      QT_PAM: { field: vital.fieldPamApi },
      QT_PERIMETRO_CEFALICO: { field: vital.fieldCephalicApi },
      QT_PERIMETRO_QUADRIL: { field: vital.fieldHipApi },
      QT_PERIMETRO_TORACICO: { field: vital.fieldThoracicApi },
      QT_PERIMITRO_ABDOMINAL: { field: vital.fieldAbdominalApi },
      QT_PERIODO: { field: vital.fieldDurationApi },
      QT_PESO: { field: vital.fieldKgWeightApi},
      QT_PESO_ATUAL: { field: vital.fieldGweightApi},
      QT_PIC_TEMP: { field: vital.fieldPicCatheterTemperatureApi },
      QT_PPA: { field: vital.fieldPpaMmhgApi },
      QT_PPC: { field: vital.fieldPpcMmhgApi },
      QT_PREGA_CUTANEA_TRICEPS: { field: vital.fieldTripleSkinFoldApi },
      QT_PRESSAO_INTRA_ABD_H2O: { field: vital.fieldPiaCmh2oApi },
      QT_PRESSAO_INTRA_CRANIO: { field: vital.fieldPicMmhgApi },
      QT_PUPILA_TAM_ESQ: { field: vital.fieldLeftPulleySizeApi },
      QT_PUPILA_TAMANHO: { field: vital.fieldRightPulleySizeApi },
      QT_PVC: { field: vital.fieldPvcMmhfApi },
      QT_PVC_H2O: { field: vital.fieldPvcCmh2oApi },
      QT_RELACAO_ABD_QUAD: { field: vital.fieldRelationshipAQApi },
      QT_SATURACAO_O2: { field: vital.fieldSaturationO2Api },
      QT_SEGMENTO_ST: { field: vital.fieldVariationApi },
      QT_SPO2R: { field: vital.fieldFcOxiApi },
      QT_SUPERF_CORPORIA: { field: vital.fieldScApi },
      QT_TEMP: { field: vital.fieldTemperatureApi },
      QT_TEMP_BERCO: { field: vital.fieldCribTemperatureApi },
      QT_TEMP_INCUBADORA: { field: vital.fieldIncubatorTemperatureApi },
      QT_TOF_BLOQ_NEURO_MUSC: { field: vital.fieldTofApi },
      QT_UMID_INCUBADORA: { field: vital.fieldIncubatorHumidityApi },
      QT_VARIACAO_GLIC: { field: vital.fieldBloodGlucoseVariationApi },
    };

    return dataMap;
  }
}

export {
  VitalSignFields,
  VitalSignFieldsMap
}
